import { Link } from 'react-router-dom';
import type { Film } from '@/lib/catalog';

export default function FilmCard({ film }: { film: Film }) {
  return (
    <Link
      to={`/detail/${film.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={film.cover}
          alt={`${film.title} 海报`}
          title={`${film.title} 神宫寺奈绪影视作品`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-md bg-primary-950/80 text-background-50 text-xs">
          {film.type}
        </span>
        <span className="absolute bottom-2.5 right-2.5 px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-medium flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {film.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3.5">
        <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
          {film.title}
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 flex items-center justify-between">
          <span>{film.year}</span>
          <span>{film.platform}</span>
        </p>
      </div>
    </Link>
  );
}